import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL?.trim() || '';
const PREFIX = '/api/manager';

export async function requestCode(email: string) {
  const { data } = await axios.post(`${baseURL}${PREFIX}/auth/request`, { email });
  return data as { sentAt: string; nextAt: string };
}

export async function verifyCode(email: string, code: string) {
  const { data } = await axios.post(`${baseURL}${PREFIX}/auth/verify`, { email, code });
  return data as {
    access_token: string;
    refresh_token: string;
    manager: {
      id: string;
      email: string;
      name: string;
      code: string;
      commissionBps: number;
      role?: 'MANAGER' | 'HEAD_MANAGER';
    };
  };
}
